import { useEffect, useRef } from 'react'
import { haptic, tg } from '../lib/telegram'
import { InstallButton } from './InstallButton'

interface Props {
  title: string
  onBack?: () => void
}

/**
 * Шапка приложения. Кнопка «назад» дублируется в нативный BackButton
 * Telegram — там она выглядит привычнее, поэтому внутри вебвью свою скрываем.
 */
export function Header({ title, onBack }: Props) {
  const handler = useRef(onBack)
  handler.current = onBack

  useEffect(() => {
    if (!tg) return
    const btn = tg.BackButton
    const fire = () => {
      haptic.impact('light')
      handler.current?.()
    }
    btn.onClick(fire)
    return () => btn.offClick(fire)
  }, [])

  useEffect(() => {
    if (!tg) return
    if (onBack) tg.BackButton.show()
    else tg.BackButton.hide()
  }, [onBack])

  return (
    <header className="header">
      <div className="header__side">
        {onBack && !tg && (
          <button type="button" className="header__back" onClick={onBack} aria-label="Назад">
            ‹
          </button>
        )}
      </div>
      <div className="header__title">{title}</div>
      <div className="header__side header__side--end">
        <InstallButton />
      </div>
    </header>
  )
}
